import { render, staticRenderFns } from "./ForgetChangePassword.vue?vue&type=template&id=4f0155f8&"
import script from "./ForgetChangePassword.vue?vue&type=script&lang=js&"
export * from "./ForgetChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports